export const matrixPopOverConfig = {
    popOverSelector: '.js-matrixPopOver',
    toggleAreaSelector: '.js-matrixPopOver__toggleArea',
    closeAreaSelectors: ['.js-matrixPopOver__overlay', '.js-RC-bookieSelection__btn'],
    activeClass: 'RC-matrixPopOver_active',
    name: 'Matrix',
    onOpen() {
        const courseTime = document.querySelector('.js-RC-courseTime');

        if (courseTime) {
            courseTime.classList.add('RC-courseTime_activeMatrix');
        }
    },
    onClose() {
        const courseTime = document.querySelector('.js-RC-courseTime');

        if (courseTime) {
            courseTime.classList.remove('RC-courseTime_activeMatrix');
        }
    }
};



// WEBPACK FOOTER //
// ./lib/js/modules/matrixPopOver/matrixPopOver.config.js